// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");

function SearchInput(props) {
  var onChange = props.onChange;
  return JsxRuntime.jsx("input", {
              className: "p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
              placeholder: "Search...",
              type: "search",
              value: props.value,
              onChange: (function ($$event) {
                  Curry._1(onChange, $$event.target.value);
                })
            });
}

var make = SearchInput;

exports.make = make;
/* react/jsx-runtime Not a pure module */
